export const FEATURE_FLAGS = {
  // Enables the pre-fetch for CDM resources.
  CDM_PREFETCH: 'bootstrap-cdm-prefetch',
  // Enables the pre-fetch for LEDM resources.
  LEDM_PREFETCH: 'bootstrap-ledm-prefetch',
  // Enables sending the ExperienceType to the `createSession` API. Feature used on the POST OOBE flow.
  ENABLE_POST_OOBE_FLOW: 'bootstrap-enable-post-oobe-flow',
  // Enables the new DRP recipe that fetch the Claim Postcard resources for CDM and LEDM resources.
  ENABLE_CLAIM_POSTCARD_FLOW: 'bootstrap-enable-claim-postcard-flow',
  // Enables the new DRP recipe that fetch the Claim Postcard resources for CDM and LEDM resources for SMB capable apps. Is dependent on the ENABLE_CLAIM_POSTCARD_FLOW feature flag.
  ENABLE_CLAIM_POSTCARD_FLOW_FOR_SMB_CAPABLE_APPS:
    'bootstrap-enable-claim-postcard-flow-for-smb-capable-apps',
  // Enables Device Platform override for iPadOS devices.
  ENABLE_IPADOS_DEVICE_PLATFORM_OVERRIDE:
    'bootstrap-enable-ipados-device-platform-override',
  // Enables logging the User Token in the `createSession` API.
  ENABLE_USER_TOKEN_LOGGING: 'bootstrap-feature-enable-user-token-loggin',
  // Enables converting CDM resource from JSON object to base64 string for claim postcard resources.
  ENABLE_CLAIM_POSTCARD_CDM_BASE64_CONVERSION:
    'bootstrap-enable-claim-postcard-cdm-base64-conversion',
  // Enables only requesting the CDM claim postcard resource.
  ENABLE_ONLY_REQUEST_CDM_CLAIM_POSTCARD:
    'bootstrap-enable-only-request-cdm-claim-postcard'
}
